// The theme toggle now lives in the NavBar, so the FooterBar no longer renders
// a floating Day/Night switch. Kept as a placeholder for future footer content.
export const FooterBar = () => {
  return null;
};
